var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.4498C14.2781 4.96116 14.2781 7.04008 13 8.55144M15.5 1.85554C17.5751 4.3107 17.5751 7.69054 15.5 10.1457M1 4.72521V7.27603C1 8.55144 1 9.18915 2.43608 9.18915H3.46288C3.72855 9.18915 3.99423 9.25929 4.224 9.38046L6.32068 10.5475C8.13014 11.555 9.61649 10.8217 9.61649 8.92769V3.07355C9.61649 1.17319 8.13014 0.446208 6.32068 1.45378L4.224 2.62078C3.99423 2.74195 3.72855 2.81209 3.46288 2.81209H2.43608C1 2.81209 1 3.4498 1 4.72521Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioPlay);
export default __webpack_public_path__ + "static/media/audioPlay.901e4d88ccf45850e8038cc0480a71af.svg";
export { ForwardRef as ReactComponent };